import Angled from "@/components/heros/angled";
import Split from "@/components/heros/split";
import Centered from "@/components/heros/centered";
import Video from "@/components/heros/video";
import Background from "@/components/heros/background";
import ImageGrid from "@/components/heros/image-grid";

export default function Hero({ fields, first, sys, includes, ...rest }) {
  let type = null;

  switch (fields.type) {
    case "Angled":
      type = (
        <Angled
          first={first}
          fields={fields}
          sys={sys}
          includes={includes}
          {...rest}
        />
      );
      break;
    case "Split":
      type = (
        <Split
          first={first}
          fields={fields}
          sys={sys}
          includes={includes}
          {...rest}
        />
      );
      break;
    case "Centered":
      type = (
        <Centered fields={fields} sys={sys} includes={includes} {...rest} />
      );
      break;
    case "Image Grid":
      // @ts-ignore
      type = <ImageGrid first={first} fields={fields} sys={sys} includes={includes} {...rest} />;
      break;
    case "Video":
      // @ts-ignore
      type = <Video first={first} fields={fields} sys={sys} includes={includes} {...rest} />;
      break;
    case "Background":
      type = (
        <Background
          first={first}
          fields={fields}
          sys={sys}
          includes={includes}
          {...rest}
        />
      );
      break;
    default:
      type = null;
  }

  return type;
}
